import React, {useEffect, useState} from 'react'
import { getCardCampanha } from '../../services/api-auto';
import styles from './styles.module.scss'
import { useHistory } from 'react-router-dom';

const HomeCardCampanha = ({campanha}) => {

    const history = useHistory()

    const goto = () => {
        history.push(`campanhas/detalhes?campanha=${campanha.id}`)
    }

    return(
        <div className={styles.wrapper} onClick={goto}>
            <img className={styles.desktopImage} src={`data:${campanha.imagemLogo.contentType};base64,${campanha.imagemLogo.fileContents}`} alt=""/>
            <div className={styles.nome}>
                {getCardCampanha.nome}
            </div>
        </div>
    )
}

export default HomeCardCampanha;